import{useState as r}from"react";function o(){var o=r(!1),e=o[0],n=o[1];return{hover:e,hoverProps:{onMouseEnter:function(){return n(!0)},onMouseLeave:function(){return n(!1)}}}}export{o as useHover};
//# sourceMappingURL=use-hover.js.map
